import tranqui from './tranquifinanzas';

export default {
  app: () => tranqui,
};
